import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-lead-demo',
    templateUrl: './lead-demo.component.html',
    styleUrls: ['./lead-demo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeadDemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
